import { Integration } from 'models/integrations'
import api from '../index'

export interface IIntegrationsAPI {
  data: {
    attributes: Integration
    id: string
    type: string
  }[]
}
export const listIntegrations = () => {
  return api
    .get<IIntegrationsAPI>('integrations')
    .then((res) => res.data)
    .then(({ data }) => data.map(({ attributes }) => attributes))
}

export default listIntegrations
